import LazyLoad from 'react-lazyload';

import { Video } from './Video';
import { Asset } from './header/header.types';
import StyleDto from '../../../../shared/style.dto';
import useComponentContentStyles from '../../hooks/useComponentContentStyles';
import { withCssModulesClassNames } from '../../common/nextMigrationHelpers';
// eslint-disable-next-line import/no-named-default
import { default as cssStyles } from '../../scss/components/_full-width-video.module.scss';

const withCssModulesClassNamesHandler = withCssModulesClassNames(cssStyles);

interface FullWidthVideoProps {
  images: Asset[];
  styles?: StyleDto[];
  anchor?: string | null;
}

const FullWidthVideo = ({ styles = [], images = [], anchor }: FullWidthVideoProps) => {
  const {
    componentStyles,
    componentContainerRef,
  } = useComponentContentStyles({ stylesProp: styles });

  return (
    images.length > 0 && (
      <section id={anchor || undefined}>
        <div className={withCssModulesClassNamesHandler('full-width-video')}>
          <div
            ref={componentContainerRef}
            style={componentStyles}
            className={withCssModulesClassNamesHandler('full-width-video__container')}
          >
            <div
              className={withCssModulesClassNamesHandler('full-width-video__inner-container')}
            >
              <LazyLoad height="100%" offset={0}>
                <Video asset={images[0]} />
              </LazyLoad>
            </div>
          </div>
        </div>
      </section>
    )
  );
};

export default FullWidthVideo;
